import Home from "./pages/Home";
// import HowDoesCureWork from "./pages/HowDoesCureWork";
import OurMandate from "./pages/OurMandate";
import JoinOurNewsletter from "./pages/JoinOurNewsletter";
// import JoinOurBoard from "./pages/JoinOurBoard";
import Strategy from "./pages/Strategy";
// import Events from "./pages/events/Events";
import Hiring from "./pages/Hiring";
import SayHi from "./pages/SayHi";

import Resources from "./pages/workshop-resources/Resources";
import Grantwriting from "./pages/workshop-resources/Grantwriting";
import ProjectPlanning from "./pages/workshop-resources/ProjectPlanning";

const routingObject = {
  "/": { Component: Home, title: "Home", route: "/" },
  // "how-does-cure-work": {
  //   Component: HowDoesCureWork,
  //   title: "How Does Cure Work?",
  //   route: "how-does-cure-work",
  // },
  "our-mandate": {
    Component: OurMandate,
    title: "Our Mandate",
    route: "our-mandate",
  },
  // vote: {
  //   Component: Vote,
  //   title: "Vote!!!",
  //   route: "vote",
  // },
  // "join-our-board": {
  //   Component: JoinOurBoard,
  //   title: "Join Our Board!",
  //   route: "join-our-board",
  // },
  sayhi: {
    Component: SayHi,
    title: "Come meet CURE!",
    route: "sayhi",
  },
  resources: {
    Component: Resources,
    title: "Resources",
    route: "resources",
  },
  grantwriting: {
    Component: Grantwriting,
    title: "Get Money for Projects",
    route: "grantwriting",
    redactFromNav: true,
  },
  "project-planning": {
    Component: ProjectPlanning,
    title: "Make It Happen",
    route: "project-planning",
    redactFromNav: true,
  },
  hiring: {
    Component: Hiring,
    title: "CURE Is Hiring!",
    route: "hiring",
  },
  strategy: {
    Component: Strategy,
    title: "Strategy Consulting!",
    route: "strategy",
  },
  // form: {
  //   Component: Form,
  //   title: "Estran Focus Groups!",
  //   route: "form",
  // },
  // formulaire: {
  //   Component: Formulaire,
  //   title: "Inscription au groupe de discussion Estran!",
  //   route: "formulaire",
  //   redactFromNav: true,
  // },
  // "app-testing": {
  //   Component: AppTesting,
  //   title: "Estran App Testing!",
  //   route: "app-testing",
  // },
  // "winter-events": {
  //   Component: Events,
  //   title: "Winter Events!",
  //   route: "winter-events",
  // },
  "join-our-newsletter": {
    Component: JoinOurNewsletter,
    title: "Join Our Newsletter!",
    route: "join-our-newsletter",
  },
};

export default routingObject;
